import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-organize-teams-modal',
  templateUrl: './organize-teams-modal.component.html',
  styleUrls: ['./organize-teams-modal.component.scss']
})
export class OrganizeTeamsModalComponent {

  constructor(private dialogRef: MatDialogRef<any>) { }

  close(result?: any) {
    this.dialogRef.close(result);
  }
}
